import { OTPEnterVerificationTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const OTPEnterVerificationTrackingSchema: Record<
  OTPEnterVerificationTrackingPoint,
  string
> = {
  [OTPEnterVerificationTrackingPoint.PageView]:
    '757adfc0-dc47-4969-8364-29d234d4e363',
  [OTPEnterVerificationTrackingPoint.NextButtonClick]:
    '8348f9c4-1ec2-4c0b-bb1d-a50435de487b',
  [OTPEnterVerificationTrackingPoint.BackButtonClick]:
    '837b8a1e-aecf-47e0-8464-5a97e7070282',
  [OTPEnterVerificationTrackingPoint.HelpButtonClick]:
    'bbc35e6e-233f-433f-a9f6-67525fb9c3ca',
  [OTPEnterVerificationTrackingPoint.ResendButtonClick]:
    'f64dfdc8-be39-4110-8d94-272905a4a2f2',
  [OTPEnterVerificationTrackingPoint.DifferentMethodButtonClick]:
    '7fe1b556-0968-448d-8e64-ef4646f2f851',
  [OTPEnterVerificationTrackingPoint.VerificationResult]:
    '533bfaa5-5cdc-4fd8-964b-1b0ae61420d7',
  [OTPEnterVerificationTrackingPoint.PhoneAlreadyUsedView]:
    'e43de258-a883-46f0-86ae-9a4b0354505a',
  [OTPEnterVerificationTrackingPoint.PhoneAlreadyUsedOkButtonClick]:
    'b1030b1e-203d-4f1f-8fd4-9e3c8c058a06',
  [OTPEnterVerificationTrackingPoint.PhoneAlreadyUsedContactUsButtonClick]:
    '4c50750f-aeb9-4900-96ca-c33b75443ac2',
  [OTPEnterVerificationTrackingPoint.EmailAlreadyUsedView]: '',
  [OTPEnterVerificationTrackingPoint.EmailAlreadyUsedOkButtonClick]: '',
  [OTPEnterVerificationTrackingPoint.EmailAlreadyUsedContactUsButtonClick]: '',
  [OTPEnterVerificationTrackingPoint.AccountBannedPopupView]:
    '1231a6be-a4ae-42e9-8206-080a5ae7d5db',
  [OTPEnterVerificationTrackingPoint.AccountBannedPopupOkButtonClick]:
    '5e57c890-0207-4ef1-8461-bf113ce35520',
  [OTPEnterVerificationTrackingPoint.AccountBannedPopupContactUsButtonClick]:
    'cc833311-623c-4e02-81af-35439e1cf975',
};

export const getOTPEnterVerificationPageTypeAndSchema = (
  trackingPoint: OTPEnterVerificationTrackingPoint
) => {
  return {
    page_type: PageType.OTPEnterVerificationPage,
    schema: OTPEnterVerificationTrackingSchema[trackingPoint],
  };
};
